import { useGetUserQuery } from '../../common'

export const useWasInNotetakerIntroExperiment = () => {
  const { data: user } = useGetUserQuery()

  const notetakerEnabledInIntroFlow = user?.growth_experiments?.notetaker_enabled_from_intro

  return notetakerEnabledInIntroFlow !== null && notetakerEnabledInIntroFlow !== undefined
}
